module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-art-6.12bd3e43.jpg";